export default __webpack_public_path__ + "static/media/goopter-software-solutions.152b979b.png";